import axios from 'axios';

const baseURL = import.meta.env.VITE_API_BASE || 'https://api.rabbitidx.com';

const client = axios.create({
    baseURL,
    withCredentials: false,
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
});

export default function useApi() {
    ////////////////////////////////////////////////////////////////////
    /// Fetch the public catalog the form needs to render: plans, addons,
    /// and signup-enabled associations.
    const loadCatalog = async () => {
        const [associations, planAndAddons] = await Promise.all([
            client.get('/api/signup/associations'),
            client.get('/api/signup/plans-and-addons'),
        ]);
        return {
            associations: associations.data,
            plans: planAndAddons.data.plans,
            addons: planAndAddons.data.addons,
        };
    };

    ////////////////////////////////////////////////////////////////////
    /// Submit the signup form. Resolves on 201; throws on any error.
    /// Caller should catch and inspect err.response.status / err.response.data.errors.
    const submit = async (form) => {
        return client.post('/api/signup', form);
    };

    return { loadCatalog, submit };
}
